import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Moment from 'react-moment';
import {Row,Col,Form} from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';

import CustomMultiSelect from '../commons/helpers/customMultiSelect'; 

import {userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import {titleCase} from '../../utils/changeCase'; 
import { checkPermissions } from '../../utils/permissions'; 
import {getSortClass,converDateToLocal} from '../../utils/commonUtilities';
import {validateEmail,imageExtension,fileSize} from '../../utils/validation'; // formValid 

import {URL_IMG} from '../../configs/urlConfigs';
import {ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, ROUTE_CLIENT_REFRESH, PAGENUMROWS_AFFILIATE, PAGING_END_INDEX, LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP, USER_STATUS,PHONE_ISD_CODE, PHONE_ISD_NUM} from '../../configs/staticConfigs'; // ROUTE_AFFILIATE_CLIENT_PROFILE
import { MSG_ASS_USER_ACTIVATED_ERROR,MSG_ASS_USER_ACTIVATED_SUCCESS,MSG_CLIENT_DELETE,MSG_ERROR, MSG_REQUIRED, MSG_CLIENT_ADD_SUCCESS, MSG_NOT_FOUND, MSG_LOGO_FORMAT, MSG_FILE_SIZE_ERROR, MSG_FILE_FORMAT_ERROR, MSG_ASS_USER_ADD_SUCCESS, MSG_ASS_USER_ADD_ERROR, MSG_ASS_USER_UPDATE_SUCCESS, MSG_ASS_USER_UPDATE_ERROR,  MSG_ASS_USER_DELETE_SUCCESS, MSG_ASS_USER_DELETE_ERROR,MSG_MAIL_RESEND} from '../../configs/msgConfigs'; // MSG_DEACTIVATED 
import { LBL_CONFIRM_UNDO_DELETE_ASSOC_USER,LBL_CONFIRM_UNDO_DELETE, LBL_DELETED, LBL_SUSPENDED, LBL_INACTIVE,LBL_APP_NAME, LBL_ASSOCIATE_USERS, LBL_ASSOCIATE_USER, LBL_BTN_ADDNEW, LBL_ADD, LBL_EDIT, LBL_DELETE, LBL_SLNUM, LBL_CREATED_DATE_TIME, LBL_NAME, LBL_EMAIL, LBL_PHONE, LBL_ROLE, LBL_LAST_LOGIN, LBL_STATUS, LBL_FIRST_NAME, LBL_LAST_NAME, LBL_MOBILE_NUMBER, LBL_EMAIL_ADDRESS, LBL_RESEND_VERIFI_EMAIL, LBL_SELECT_ROLE, LBL_POSITION, LBL_DEPARTMENT, LBL_ACTIVE, LBL_SELECT_STATUS, LBL_USER_CREATED_ON, LBL_LAST_LOGGED_IN,LBL_MY_PROFILE,LBL_CONFIRM_DELETE_ASSOC_USER, LBL_PRIMARY_CONTACT,LBL_PRIMARY,LBL_RESEND_EMAIL,LBL_CONFIRM_DELETE } from '../../configs/labelConfigs'; // LBL_CLIENT

import {associateUserActivateAction,assUserListAction, assUserDeptListAction, assUserRolesListAction, assUserAddAction, assUserUpdateAction, associateUserDeleteAction } from '../../actions/assUserActions';
import {clearAction, resendEmailAction, assocUserDeactiveAction} from '../../actions/commonActions';
import * as types from '../../actions';

import AssociateAddEditComponent from './associatesAddEditComponent';

import ModalWindow from './helpers/modalWindow';
import Paginator from './helpers/paginator';
import Toast from './helpers/toast';
import Filter from './helpers/filterBy';

class AssociatesListComponent extends Component {

   constructor(props){
      super(props)

      this.state = {
         location: this.props.location, 
         userGroup: 0, 
         departmentsList: [],
         rolesList: [],
         assocUsersAllData: [], 
         activeUserData: {
            profile_picture: '',
            profile_pic_url: '',
            first_name: '',
            last_name: '', 
            email: '', 
            mobile: '', 
            role: 0, 
            status: '1', 
            position: '',
            department: [],
            created_on: '',
            last_login: '',
            primary_contact:false,  
            is_active:true 
         },   
         profilePictureAdded: 0, 
         isLogoValid: true, 
         logoLabel: MSG_LOGO_FORMAT, 
         activeUserId: 0, 
         activeUserProfileId: 0, 
         activeUserName: '', 
         activePage:1,
         startIndex : 0, 
         endIndex : PAGING_END_INDEX,
         activeRowId:0,    
         perPageCount:PAGENUMROWS_AFFILIATE,
         sortField:'-id',
         sortOrder:'',  
         isFilterOn: false,
         assocUserActive: 0, 
         assocUserShown: 0, 
         clientId:'',   
         clientName:'', 
         toastMessage:'',
         toastFlag:false,
         toastSuccess:true, 
         toastMessagePop:'',
         toastFlagPop:false,
         toastSuccessPop:true, 
         searchString:'',
         formErrors:{
            profile_picture: '',
            first_name: '',
            last_name: '', 
            email: '', 
            mobile: '', 
            role: 0, 
            status: '', 
            department: ''
         },
         deptMultiSelList: [],
         myProfileId: 0,
         clientStatus: '0'
      } 

      this.openModal                = this.openModal.bind(this);
      this.onHandleChange           = this.onHandleChange.bind(this);
      this.onShowActionButtons      = this.onShowActionButtons.bind(this);
      this.onHideActionButtons      = this.onHideActionButtons.bind(this);
      this.resetActiveUser          = this.resetActiveUser.bind(this); 
      this.validateAddUser          = this.validateAddUser.bind(this); 
      this.onSaveFormData           = this.onSaveFormData.bind(this);
      this.loadMultiSelDeptValues   = this.loadMultiSelDeptValues.bind(this); 
      this.handleChangeMultiSel     = this.handleChangeMultiSel.bind(this); 

      this.modal           = React.createRef(); 
      this.modalUndoDelete = React.createRef(); 
      this.modalDelete     = React.createRef(); 
   }

   onAssocUserAddSuccess = () => {
      this.onModalFormReset();
      this.modal.current.handleModelClose();
      this.setState({toastSuccess:true, toastFlag:true, toastMessage:MSG_ASS_USER_ADD_SUCCESS});
      setTimeout(()=> {
         this.onCloseToast(); 
      }, 3000);
      this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
   }

   onAssocUserUpdateSuccess = () => { 
      this.onModalFormReset();
      this.modal.current.handleModelClose();
      this.setState({toastSuccess:true, toastFlag:true, toastMessage:MSG_ASS_USER_UPDATE_SUCCESS});
      setTimeout(()=> {
         this.onCloseToast(); 
      }, 3000);
      this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
   }

   resendEmail =(userId)=>{
      this.props.resendEmailAction(userId);
  }

   onHandleChange = (e) =>{
      // const {name,value}  = e.target;
      const {name}  = e.target;
      const value = e.target.type === "file" ? e.target.files[0] : e.target.value;  
      let formErrors = this.state.formErrors;
  
      let activeUserData = this.state.activeUserData; 
      let isLogoValid = true;
      let profilePictureAdded = this.state.profilePictureAdded;
      // let logoLabel = this.state.logoLabel; 
      formErrors.profile_picture = ''; 
      switch(name){
         case 'file_userProfile':
               if (!fileSize(value.size)) {
                  formErrors.profile_picture = MSG_FILE_SIZE_ERROR; 
                  isLogoValid = false;
                  profilePictureAdded = 0; 
               }
               else if(!imageExtension(value.name)){
                  formErrors.profile_picture = MSG_FILE_FORMAT_ERROR;
                  isLogoValid = false;
                  profilePictureAdded = 0; 
               }    
               else {
                  profilePictureAdded = 1; 
                  isLogoValid = true;
                  formErrors.profile_picture = ''; 
                  if(imageExtension(e.target.files[0].name)){
                     activeUserData.profile_pic_url = URL.createObjectURL(e.target.files[0]);
                     activeUserData.profile_picture = e.target.files[0]; // URL.createObjectURL(e.target.files[0]);
                  }
               }  
               break; 
         case 'txt_first_name': formErrors.first_name = value.trim()==='' ? MSG_REQUIRED : "";
            activeUserData.first_name = value; 
            break;  
         case 'txt_last_name': formErrors.last_name = value.trim()==='' ? MSG_REQUIRED : ""; 
            activeUserData.last_name = value; 
            break;       
         case 'txt_email':
               formErrors.email =  value.length <=0 || validateEmail(value) === false ? MSG_REQUIRED : "";
               activeUserData.email = value; 
               break;  
         case 'txt_mobile': formErrors.mobile = value.trim()==='' ? MSG_REQUIRED : ""; 
            activeUserData.mobile = value; 
            break;        
         case 'sel_role': formErrors.role = value===0 ? MSG_REQUIRED : ""; 
            activeUserData.role = value; 
            break;   
         case 'txt_position': activeUserData.position = value; 
            break;     
         case 'sel_status': formErrors.status = parseInt(value,10)===0 ? MSG_REQUIRED : ""; 
            activeUserData.status = value; 
            break;              
         default :
            break;
      }
      this.setState({formErrors,activeUserData,isLogoValid,profilePictureAdded});
   }

   onPhoneInputChange = (value, data, event, formattedValue) =>{
      let activeUserData   = this.state.activeUserData;     
      let formErrors   = this.state.formErrors;     ;
      activeUserData['mobile'] = formattedValue;
      formErrors.mobile = value.trim()===data.dialCode ? MSG_REQUIRED : ""
      formErrors.mobile = formattedValue.trim().length<5 ? MSG_REQUIRED : ""

        this.setState({formErrors,activeUserData});
   }
   
   loadMultiSelDeptValues() {
      let allDept = []; 
      if(this.state.departmentsList.length > 0) {
         let tmpObj = {}; 
         // let tmpObj = { value:'0', label:'Select All', selected:false; 
         this.state.departmentsList.forEach((item,index) => { 
            tmpObj = {value:item.id, label:titleCase(item.name)}; 
            allDept.push(tmpObj); 
         } ) 
         this.setState({deptMultiSelList:allDept}); 
      }
   }

   handleChangeMultiSel = (selectedDepts) =>{
      let actUserDept = []; 
      selectedDepts.forEach((item) => {
         actUserDept.push(item.value);
      });
      let actUserData = this.state.activeUserData; 
      actUserData.department = actUserDept; 
      this.setState({activeUserData:actUserData}); 
  }

   handleChangeMultiSel22=(select) =>{
      let selDept = this.state.deptMultiSelList; 
      let newSelDept = []; 
      let actUserDept = []; 
      newSelDept = selDept.map((item) => {
         if(parseInt(item.value,10)===parseInt(select[0].value,10)) {
            item.selected = !item.selected;
            if(item.selected) actUserDept.push(item.value); 
            return item;
         }
         else {
            if(item.selected) actUserDept.push(item.value); 
            return item; 
         }
      });
      let actUserData = this.state.activeUserData; 
      actUserData.department = actUserDept; 
      this.setState({deptMultiSelList:newSelDept, activeUserData:actUserData}); 
   }

   onShowFilterBy = () => {
      this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn }));
      document.getElementById("filterByMenu").classList.toggle('active');
      document.getElementById("filterIcon").classList.toggle('active');
   }

   onShowActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.toggle('show');
      dropdownMenu.classList.toggle('show');      

      if(this.state.activeRowId===0){   
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus();
      }else if(this.state.activeRowId===rowId){ 
         this.setState({activeRowId:0}); 
      }else if(this.state.activeRowId!==rowId){   
         dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
         dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
         dropdown.classList.toggle('show');
         dropdownMenu.classList.toggle('show');
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus();
      }        
      
   }    

   onHideActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.remove('show');
      dropdownMenu.classList.remove('show');
      this.setState({activeRowId:0});
   }

   resetActiveUser() {
      let activeUserData = {
         profile_picture: '',
         profile_pic_url: '', 
         first_name: '',
         last_name: '', 
         email: '', 
         mobile: '', 
         role: 0, 
         status: '1', 
         position: '',
         department: [],
      };   
      let allDept = []; 
      if(this.state.departmentsList.length > 0) {
         let tmpObj = {}; 
      
         this.state.departmentsList.forEach((item,index) => { 
            tmpObj = {value:item.id, label:titleCase(item.name)}; 
            allDept.push(tmpObj); 
         } ) 
      }
      this.setState({activeUserData:activeUserData, isLogoValid:true, activeUserId:0, activeUserProfileId:0, activeUserName:'', deptMultiSelList:allDept}); 
   }

   openModal(e,userId) {
      if(!userId || userId===0) this.resetActiveUser(); 
      this.resetFormErrors();
      this.modal.current.handleOpenModal();
      setTimeout(()=> {
         if(document.getElementById('txt_first_name')) {
             document.getElementById('txt_first_name').focus(); 
         }
     }, 500); 
   }      

   editBtnClick = (e,refId) =>{  
      this.state.assocUsersAllData.forEach((rObj) => {
          if(refId===rObj.id) {
              let activeUserId = rObj.user.id; 
              let activeUserProfileId = rObj.id; 
              let pic = rObj.profile_picture; 
              if(pic && pic.length > 4 && pic.substring(pic.length-4)==='null') pic = '';
              let activeUserData =  {
                  profile_picture: pic,
                  profile_pic_url: pic,
                  first_name: rObj.user.first_name,
                  last_name: rObj.user.last_name,
                  email: rObj.user.email,
                  mobile: rObj.phone_number, 
                  role: rObj.role.id, 
                  status: rObj.status.toString(),
                  position: rObj.position,
                  department: rObj.department,
                  created_on: rObj.created_on,
                  last_login: rObj.user.last_login,
                  primary_contact: rObj.primary_contact,
                  email_verified: rObj.email_verified,
                  is_active: rObj.is_active,
               }
               // inputVal : 123
               let allDept = []; 
               if(this.state.departmentsList.length > 0) {
                  this.state.departmentsList.forEach((item,index) => { 
                     if(rObj.department.includes(item.id)) allDept.push({value:item.id, label:titleCase(item.name), inputVal: item.id}); 
                     else allDept.push({value:item.id, label:titleCase(item.name)}); 
                  } ) 
               }
              // console.log('Edit actUserData: '+JSON.stringify(activeUserData));   
              this.setState({activeUserProfileId:activeUserProfileId, activeUserId:activeUserId, activeUserData:activeUserData, isLogoValid:true, profilePictureAdded:0,  deptMultiSelList:allDept});
              this.openModal(this,refId);
          }
      }); 

   }

   deleteBtnClick = (rowId,name) =>{
      this.setState({
         activeUserId:rowId,
         activeUserName:name          
      }); 
      this.modalDelete.current.handleOpenModal();
      this.modal.current.handleModelCloseOnly();     
   }
   deleteUndoBtnClick = (rowId,name) =>{
      this.setState({
         activeUserId:rowId,
         activeUserName:name          
      }); 
      this.modalUndoDelete.current.handleOpenModal(); 
      this.modal.current.handleModelCloseOnly();     
   }

   onDeleteAction = () =>{ 
      let activeUserId = this.state.activeUserId;
      this.props.associateUserDeleteAction(activeUserId);
      this.modalDelete.current.handleModelClose();  
      this.modal.current.handleModelClose();                          
   }
   onActivateAction = () =>{ 
      let activeUserId = this.state.activeUserId;
      this.props.associateUserActivateAction({user_id:activeUserId});
      this.modalUndoDelete.current.handleModelClose();  
      this.modal.current.handleModelClose();                          
   } 

   deletePopup = () => {
      let fullName = this.state.activeUserData.first_name+' '+this.state.activeUserData.last_name; 
      this.deleteBtnClick(this.state.activeUserId,fullName); 
   }
   deleteUndoPopup = () => {
      let fullName = this.state.activeUserData.first_name+' '+this.state.activeUserData.last_name; 
      this.deleteUndoBtnClick(this.state.activeUserId,fullName); 
   }

   resetFormErrors=()=>{
      let formErrors = {
         profile_picture: '',
         first_name: '',
         last_name: '', 
         email: '', 
         mobile: '', 
         role: 0, 
         status: '', 
         department: ''
      };   
      this.setState({formErrors});  
   }

   validateAddUser() {
      let formErrors = this.state.formErrors;
      let activeUserData = this.state.activeUserData; 
      let picURL = activeUserData.profile_picture; 
      let isLogoValid = this.state.isLogoValid;
      let logoLabel = this.state.logoLabel; 
      let foundIssue = 0; 
      let profilePictureAdded = this.state.profilePictureAdded; 
        
      if (profilePictureAdded > 0 && picURL!=='') {
         if(!fileSize(picURL.size)) { logoLabel = MSG_FILE_SIZE_ERROR; isLogoValid = false; foundIssue = 1; }
         else if(!imageExtension(picURL.name)){ logoLabel = MSG_FILE_FORMAT_ERROR; isLogoValid = false; foundIssue = 1; }    
      }
      if(activeUserData.first_name.trim()==='') {
         formErrors.first_name = MSG_REQUIRED; foundIssue = 1;
      }
      if(activeUserData.last_name.trim()==='') {
         formErrors.last_name = MSG_REQUIRED; foundIssue = 1;
      }
      if(activeUserData.email.trim()==='' || validateEmail(activeUserData.email) === false) {
         formErrors.email = MSG_REQUIRED; foundIssue = 1;
      }
      if(activeUserData.mobile.trim()==='') {
         formErrors.mobile = MSG_REQUIRED; foundIssue = 1;
      }
      if(parseInt(activeUserData.role,10)===0) {
         formErrors.role = MSG_REQUIRED; foundIssue = 1;
      }
      if(parseInt(activeUserData.status,10)===0) { 
         formErrors.status = MSG_REQUIRED; foundIssue = 1;
      }

      this.setState({formErrors,activeUserData,isLogoValid,logoLabel}); 
         
      if(foundIssue===0) {
         return true; 
      }
      else {
         return false; 
      }
   }

   onSaveFormData = (e) =>{
      e.preventDefault();

      if(this.validateAddUser()){ 
         const activeUserId = this.state.activeUserId; 
         const data         = new FormData(); 
         const userData     = this.state.activeUserData;

         
         data.append('assUserId', activeUserId);
         if(this.state.profilePictureAdded > 0) data.append('profile_picture', userData.profile_picture);             
         data.append('first_name', userData.first_name);
         data.append('last_name', userData.last_name);
         data.append('email', userData.email);
         data.append('mobile', userData.mobile);
         data.append('role', userData.role);
         data.append('status', userData.status);
         data.append('position', userData.position);
         data.append('department', userData.department.join(',')); 
         // if(userData.department.length) {
         //    userData.department.forEach(item => { 
         //          data.append('department[]', item);
         //    }); 
         // }
         // else {
         //    data.append('department[]', '');
         // }
         if(activeUserId > 0){
            data.append('send_mail', "0");
            this.props.assUserUpdateAction(data); ;
         }else{
            this.props.assUserAddAction(data); 
         }  
      }
      else {
         return false; 
      }
   }

   onModalFormReset = () =>{       
      this.setState({ activeUserId:0, activeUserProfileId:0, activeUserName:''}); 
   }
   
   onPagePrevious = (e) =>{
      const {
          startIndex, endIndex        
      } = this.state
      let previousPage = startIndex+1-PAGING_END_INDEX
      this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:previousPage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
      if(startIndex===0){
          this.setState({
              activePage: previousPage,
              startIndex : startIndex,
              endIndex : endIndex
          });  
      }else{
          this.setState({
              activePage: previousPage,
              startIndex : startIndex - PAGING_END_INDEX,
              endIndex : endIndex - PAGING_END_INDEX
          });  
      }                           
   }

   onPageUp = (e) => { 

      this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:e.target.id,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
 
      this.setState({
          activePage: Number(e.target.id)                   
      });
   }

   onPageNext = (e) =>{   
      const {
          startIndex,endIndex            
      } = this.state     
      const {
          totalPage            
      } = this.props
             
      let nextPage = startIndex+1+PAGING_END_INDEX;
      this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:nextPage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
      
      if(endIndex===totalPage || totalPage<=PAGING_END_INDEX){
          this.setState({
              activePage: nextPage,
              startIndex : startIndex,
              endIndex : endIndex
          }); 
      }else{
          this.setState({
              activePage: nextPage,
              startIndex : startIndex + PAGING_END_INDEX,
              endIndex : endIndex + PAGING_END_INDEX
          });  
      }                                   
   }

   onSort = (event,sortKey) =>{        
      let sOrder = '';
      if(this.state.sortField===sortKey){         
          sOrder = (this.state.sortOrder==='-') ? '' : '-';
          this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:this.state.activePage,column:sOrder+this.state.sortField,search:this.state.searchString});
          this.setState({ sortOrder:sOrder });            
      }else{
          this.setState({ sortField:sortKey });
          this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+sortKey,search:this.state.searchString});
      }   
   }

   onCloseToast = () =>{
      this.setState({toastFlag:false,toastMessage:'',toastSuccess:false,toastFlagPop:false,toastMessagePop:'',toastSuccessPop:false});
   } 

   onsearchString = (e)=>{
      this.setState({searchString:e.target.value})
      this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:e.target.value});
   }

   setToasterState(isEnabled,message,isSucces,isAutoHide=true){
      this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
      if(isAutoHide){
          setTimeout(()=> {
              this.onCloseToast();
          }, 3000);
      }
      // else{
      //     setTimeout(()=> {
      //         this.onCloseToast();
      //     }, 10000000000000);
      // }      
  }

   setStateUpdate(numRows,totalPage,activity,errorData,status){
      let formErrors = this.state.formErrors;

      if(activity===types.CLIENT_QUICK_ADD_SUCCESS){
         this.modal.current.handleModelClose();
         this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
         this.setToasterState(true,MSG_CLIENT_ADD_SUCCESS,true,false);       
      }else if(activity===types.CLIENT_QUICK_ADD_ERROR){      
            if(status===400){
               if(errorData.hasOwnProperty('company_name')){
                  formErrors.companyName = errorData.company_name[0];
               }else if(errorData.hasOwnProperty('email')){
                  formErrors.emailAddress = errorData.email[0];
               }else{
                  this.setToasterState(true,JSON.stringify(errorData),false);
               }                       
               this.setState(formErrors);
            }else{
               this.modal.current.handleModelClose();
               if(errorData.hasOwnProperty('message')){ 
                  this.setToasterState(true,errorData.message,false);
               }else{
                  this.setToasterState(true,JSON.stringify(errorData),false);
               }
            }
            
      }else if(activity===types.CLIENT_ACTIVE_DEACTIVE_SUCCESS){
         if (numRows===1 && totalPage > 1){
            let page = this.state.activePage-1;
            this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:page,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
        }else{
            this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
        }    
        this.setToasterState(true,MSG_CLIENT_DELETE,true);   
      }else if(activity===types.CLIENT_ACTIVE_DEACTIVE_ERROR){
         this.setToasterState(true,MSG_ERROR,false); 
      }   
   }

   onHandleChange=(e)=>{
      let value = e.target.value;
      this.setState({clientStatus:value});
      this.props.assUserListAction({status:value,pageSize:this.state.perPageCount,page:1,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});


   } 

   componentDidUpdate(prevProps) {
      const {isFilterOn,numRows,totalPage,activity,errorData,status,subactivity,assocUserActive} = this.props;    
      
      if (assocUserActive !== prevProps.assocUserActive && Number(assocUserActive) && this.state.assocUserShown > 0) {
         this.editBtnClick('',assocUserActive);    
         this.props.assocUserDeactiveAction(0); 
      }

      if (isFilterOn !== prevProps.isFilterOn) {
         this.inputFilter.click();   
      }else if (activity !== prevProps.activity) {
         this.setStateUpdate(numRows,totalPage,activity,errorData,status);
         this.props.clearAction();
      }

      if (activity && (status !== prevProps.status || activity!==prevProps.activity)) {
         var arrResp = activity.split('~~'); 
         var actString = arrResp[0]; 
         
         if(activity===types.RESEND_EMAIL_SUCCESS){
            this.setToasterState(true,MSG_MAIL_RESEND,true,false);
        }else if(activity===types.RESEND_EMAIL_ERROR){
            this.setToasterState(true,JSON.stringify(errorData),false);
        } 

         if(actString===types.DEPARTMENT_LIST_ASSOC_USER_SUCCESS) {  
            if(this.props.hasOwnProperty('departmentsList')) {
               if(this.props.departmentsList.length===0) {
                     this.setState({departmentsList: []}, () => {
                        this.loadMultiSelDeptValues(); 
                     } ); 
               }
               else {     
                     this.setState({departmentsList: this.props.departmentsList}, () => {
                        this.loadMultiSelDeptValues(); 
                     } );                  
               }
            }
         }  
         else if(actString===types.ROLES_LIST_ASSOC_USER_SUCCESS) { 
            if(this.props.hasOwnProperty('rolesList')) {
               if(this.props.rolesList.length===0) {
                     this.setState({rolesList: []}); 
               }
               else {     
                     this.setState({rolesList: this.props.rolesList});                  
               }
            }
         } 
         else if(actString===types.ASS_USER_LIST_SUCCESS) { 
            if(this.props.hasOwnProperty('assocUsersAllData')) {
               if(this.props.assocUsersAllData.length===0) {
                     this.setState({assocUsersAllData: []}); 
               }
               else {     
                     this.setState({assocUsersAllData: this.props.assocUsersAllData}, () => {
                        let assocUserActive = this.props.assocUserActive; 
                        if (Number(assocUserActive) > 0 && this.state.assocUserShown===0) {
                           this.setState({assocUserShown:1});
                           this.editBtnClick('',assocUserActive);   
                           this.props.assocUserDeactiveAction(0); 
                        }
                     });     
                     // console.log('this.props.assocUsersAllData: '+JSON.stringify(this.props.assocUsersAllData));              
               }
            }
         } 
         else if(actString===types.ASS_USER_ADD_SUCCESS) { 
            if(status===200) {
               this.onModalFormReset();
               this.modal.current.handleModelClose();
               this.setState({toastSuccess:true, toastFlag:true, toastMessage:MSG_ASS_USER_ADD_SUCCESS});
               setTimeout(()=> {
                  this.onCloseToast(); 
               }, 3000);
               this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
            }
            else {
               let errorMsg = ''; // ' - '+statusText;  
               if(status===400) {
                  errorMsg = '- Email address already exists'; // ' - '+statusText;  
               }
               else if(this.props.hasOwnProperty('errorData')) {
                  errorMsg = (this.props.errorData.hasOwnProperty('message')) ? ' - '+this.props.errorData.message : ''; 
               } 
               this.setState({toastSuccessPop:false, toastFlagPop:true, toastMessagePop:MSG_ASS_USER_ADD_ERROR+errorMsg});
            } 
         } 
         else if(actString===types.ASS_USER_ADD_ERROR) { 
            let errorMsg = ''; // ' - '+statusText;  
            if(status===400) {
               errorMsg = ' - Email address already exists'; // ' - '+statusText;  
            }
            else if(this.props.hasOwnProperty('errorData')) {
               errorMsg = (this.props.errorData.hasOwnProperty('message')) ? ' - '+this.props.errorData.message : ''; 
            } 
            this.setState({toastSuccessPop:false, toastFlagPop:true, toastMessagePop:MSG_ASS_USER_ADD_ERROR+errorMsg});
         }
      }

      if (subactivity && (status !== prevProps.status || subactivity!==prevProps.subactivity)) {
         if(subactivity===types.ASS_USER_UPDATE_SUCCESS) { 
            if(status===200) {
               this.onModalFormReset();
               this.modal.current.handleModelClose();
               this.setState({toastSuccess:true, toastFlag:true, toastMessage:MSG_ASS_USER_UPDATE_SUCCESS});
               setTimeout(()=> {
                  this.onCloseToast(); 
               }, 3000);
               this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
            }
            else {
               let errorMsg = ''; // ' - '+statusText;  
               if(status===400) {
                  errorMsg = '- Email address already exists'; // ' - '+statusText;  
               }
               else if(this.props.hasOwnProperty('errorData')) {
                  errorMsg = (this.props.errorData.hasOwnProperty('message')) ? ' - '+this.props.errorData.message : ''; 
               } 
               this.setState({toastSuccessPop:false, toastFlagPop:true, toastMessagePop:MSG_ASS_USER_UPDATE_ERROR+errorMsg});
            } 
         }
         else if(subactivity===types.ASS_USER_UPDATE_ERROR) { 
            let errorMsg = ''; // ' - '+statusText;  
            if(status===400) {
               errorMsg = '- Email address already exists'; // ' - '+statusText;  
            }
            else if(this.props.hasOwnProperty('errorData')) {
               errorMsg = (this.props.errorData.hasOwnProperty('message')) ? ' - '+this.props.errorData.message : ''; 
            } 
            this.setState({toastSuccessPop:false, toastFlagPop:true, toastMessagePop:MSG_ASS_USER_UPDATE_ERROR+errorMsg});
         } 
         else if(subactivity.search(types.ASSOCIATE_USER_DELETE_SUCCESS)>=0) { 
            if(status===200) {
               this.setState({toastSuccess:true, toastFlag:true, toastMessage:MSG_ASS_USER_DELETE_SUCCESS});
               setTimeout(()=> {
                  this.onCloseToast(); 
               }, 3000);
               this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
            }
            else {
               let errorMsg = ''; // ' - '+statusText;  
               if(this.props.hasOwnProperty('errorData')) {
                  errorMsg = (this.props.errorData.hasOwnProperty('message')) ? ' - '+this.props.errorData.message : ''; 
               } 
               this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_ASS_USER_DELETE_ERROR+errorMsg});
            } 
         }else if(subactivity.search(types.ASS_USER_ACTIVATE_SUCCESS)>=0) { 
            if(status===200) {
               this.setState({toastSuccess:true, toastFlag:true, toastMessage:MSG_ASS_USER_ACTIVATED_SUCCESS});
               setTimeout(()=> {
                  this.onCloseToast(); 
               }, 3000);
               this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
            }
            else {
               let errorMsg = ''; // ' - '+statusText;  
               if(this.props.hasOwnProperty('errorData')) {
                  errorMsg = (this.props.errorData.hasOwnProperty('message')) ? ' - '+this.props.errorData.message : ''; 
               } 
               this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_ASS_USER_DELETE_ERROR+errorMsg});
            } 
         }
         else if(subactivity.search(types.ASSOCIATE_USER_DELETE_ERROR)>=0) { 
            let errorMsg = ''; // ' - '+statusText;  
            if(this.props.hasOwnProperty('errorData')) {
               errorMsg = (this.props.errorData.hasOwnProperty('message')) ? ' - '+this.props.errorData.message : ''; 
            } 
            this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_ASS_USER_DELETE_ERROR+errorMsg});
         }
         else if(subactivity.search(types.ASS_USER_ACTIVATE_ERROR)>=0) { 
            let errorMsg = ''; // ' - '+statusText;  
            if(this.props.hasOwnProperty('errorData')) {
               errorMsg = (this.props.errorData.hasOwnProperty('message')) ? ' - '+this.props.errorData.message : ''; 
            } 
            this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_ASS_USER_ACTIVATED_ERROR+errorMsg});
         }
     }
     
   }

   componentDidMount() {
      const { location } = this.props;
      // if(location.state!==undefined && location.state.hasOwnProperty('clientName')){ // to show success message after deactivate
      //    this.setToasterState(true,LBL_CLIENT+' '+location.state.clientName+' '+MSG_DEACTIVATED,true); 
      //    window.history.pushState(null, '');
      // }
      let userGroupData = userGroupUrlCheck(location);
      let userGroup = ''; 
      let myProfileId = 0; 
      
      if(userGroupData!==undefined){
         userGroup   = userGroupData.user_group; 
         myProfileId = userGroupData.associate_id; 
      }   
      if(userGroup===LOGIN_AFFILIATE_GROUP){
         document.body.classList.add('body-affiliate'); 
      }else if(userGroup===LOGIN_CLIENT_GROUP){
         document.body.classList.add('body-client'); 
      }
      document.title = LBL_APP_NAME+" - "+LBL_ASSOCIATE_USERS;
      // this.props.assUserListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
      this.props.assUserDeptListAction(); 
      this.props.assUserRolesListAction(); 
      this.props.assUserListAction({status:this.state.clientStatus,pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
      this.setState({userGroup:userGroup,myProfileId:myProfileId}); 
   }
   
   render(){

        const { activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess,toastMessagePop,toastFlagPop,toastSuccessPop,myProfileId,activeUserProfileId,sortField,sortOrder, } = this.state; 
        let formErrors      = this.state.formErrors;
        const {totalPage,status} = this.props;   
        let assocUsersAllData = {}; 
                
        if(this.props.hasOwnProperty('assocUsersAllData')) assocUsersAllData = this.props.assocUsersAllData;   
            
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        let is_active = true; 
        let login_as_sa_user = 0; 
        if(userGroupData!==undefined){
            userGroup   = userGroupData.user_group; 
            is_active   = userGroupData.is_active; 
            login_as_sa_user   = userGroupData.login_as_sa_user; 
        }
        if(status===401 || status===403){
            if(userGroup===LOGIN_AFFILIATE_GROUP){
               return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            } else if(userGroup===LOGIN_CLIENT_GROUP){
               return <Redirect to={ROUTE_CLIENT_REFRESH} />;
            } else{
               return <Redirect to={ROUTE_REFRESH} />;
            }
        }
        let logoUrl = require('../../'+URL_IMG+'profile-image.png');
        let isLogoValid = this.state.isLogoValid; 
        let activeUserData = this.state.activeUserData; 
        let logoLabel = this.state.logoLabel; 
        if(this.state.activeUserData.hasOwnProperty('profile_pic_url') && this.state.activeUserData.profile_pic_url){
            logoUrl = this.state.activeUserData.profile_pic_url;
        }
        
        let rolesList = this.state.rolesList; 
        let showDeleteLinkLeft = (this.state.activeUserId > 0 && !this.state.activeUserData.primary_contact && this.state.activeUserData.is_active) ? 'yes' : ''; 
        let showUndoDeleteLinkLeft = (this.state.activeUserId > 0 && !this.state.activeUserData.primary_contact && !this.state.activeUserData.is_active) ? 'yes' : ''; 
        let timeZone =  getUserTimeZone(this.props.location);
        //for superadmin removing checking for add associate permission
        let isModifyAllowed = false;
        if(login_as_sa_user === 1){
            isModifyAllowed = true;
        }else{
         isModifyAllowed = is_active===true && checkPermissions('associateusers','modify')
        }
        let addNew = "";
        if(isModifyAllowed){
            addNew = <div className="to-right"><button className="btn btn-primary launch-modal" onClick={(e) => this.openModal(e,0)}>{LBL_BTN_ADDNEW}</button></div>
        } 
        return(
            <React.Fragment>
            <div className="col-md-12">
               <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

               <div className="box">
                  <div className="box-head">
                     {/* <div className="dataTables_filter"><label>
                        <input type="search" className="" placeholder="Search" id="my-search-input" onChange={this.onsearchString} /></label>
                     </div> 
                     <div className="filter-btn-wrapper">
                        <button id="filterIcon" ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className="filter-btn text-primary"><i className="las la-filter"></i></button>
                     </div> */}

                     {addNew}
                     <div className="to-right">
                        <div className="form-group">
                              <div className="form-group select-input">
                              <select name="sel_role" value={this.state.clientStatus} onChange={this.onHandleChange} tabIndex="1" >
                                 <option value='0'>{LBL_ACTIVE}</option>
                                 <option value='1'>{LBL_SUSPENDED}</option>
                                 <option value='2'>{LBL_DELETED}</option>
                              </select>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="box-content">
                     <div className="table-responsive">
                        <table id="data-table" className="table" style={{width:"100%"}}>
                           <thead>
                              <tr>						 
                                 <th>{LBL_SLNUM}</th>
                                 <th onClick={(e) => this.onSort(e,'created_on')} className="created-date-time spanPointer" >{LBL_CREATED_DATE_TIME} <i className={sortField=='created_on' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th onClick={(e) => this.onSort(e,'user__first_name')} className=" spanPointer">{LBL_NAME} &nbsp;  <i className={sortField=='user__first_name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th onClick={(e) => this.onSort(e,'user__email')} className="mobile-number  spanPointer">{LBL_EMAIL} <i className={sortField=='user__email' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th onClick={(e) => this.onSort(e,'phone_number')} className="date-join spanPointer">{LBL_PHONE} <i className={sortField=='phone_number' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th onClick={(e) => this.onSort(e,'role__name')} className="spanPointer">{LBL_ROLE}  <i className={sortField=='role__name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th onClick={(e) => this.onSort(e,'user__last_login')} className="date-join spanPointer">{LBL_LAST_LOGIN} <i className={sortField=='user__last_login' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th onClick={(e) => this.onSort(e,'status')} className="date-join spanPointer">{LBL_STATUS} <i className={sortField=='status' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th>&nbsp;</th>
                              </tr>  
                           </thead>
                           <tbody>
                              {Array.isArray(assocUsersAllData) && (assocUsersAllData.length===0) && 
                                 <tr>
                                    <td colSpan="9" className="text-center">{MSG_NOT_FOUND}</td>
                                 </tr>
                              }
                              {Array.isArray(assocUsersAllData) && (assocUsersAllData.length > 0) && assocUsersAllData.map((item, index)  => { 
                                 let indexNum = (PAGENUMROWS_AFFILIATE*(activePage-1))+index+1;
                                 let userProfileId = item.user.id;
                                 let isEmailVerified = item.email_verified===false?'Not Verified':'';
                                 let fullName = (item.user.first_name+' '+item.user.last_name).trim(); 
                                 let uStat = USER_STATUS.filter(us => Number(us.statusCode)===Number(item.status)); 
                                 let createdDate=converDateToLocal(item.actual_created_on,"+00:00",'ddmmyyyyhhmm'); 
                                 return (
                                    <tr key={item.id}>
                                       <td>{indexNum}</td> 
                                       <td>{createdDate} 
                                       {/* <Moment format="DD/MM/YYYY HH:mm">{item.created_on}</Moment> */}
                                       </td>
                                       {isModifyAllowed &&
                                          <td><Link to="#" onMouseDown={(e) => this.editBtnClick(e,item.id)}>{fullName}</Link>{item.primary_contact && <sup>{' '+LBL_PRIMARY}</sup>}</td>
                                       }
                                       {!isModifyAllowed && 
                                          <td>{fullName}{item.primary_contact && <sup>{' '+LBL_PRIMARY}</sup>}</td>
                                       }
                                       <td style={{ whiteSpace: 'nowrap', width: '1%' }}>
                                          <div>{item.user.email}</div>
                                          <div className="divFloatLeft"><small className="block text-red">{isEmailVerified}</small></div>
                                          {item.id > 0 && isEmailVerified.length > 0 && <Link className={'resend-btn float-right'} to="#" onClick={e => this.resendEmail(userProfileId)}>{LBL_RESEND_EMAIL}</Link>}
                                       </td>
                                       <td>{item.phone_number}</td>
                                       <td>{(item.role && item.role.name)?titleCase(item.role.name):''}</td>
                                       <td>{ (item.user.last_login!=='') && (item.user.last_login!==null) && converDateToLocal(item.user.last_login,"+00:00",'ddmmyyyyhhmm')}</td>
                                       <td>{titleCase(uStat[0].statusString)}</td>
                                       <td>
                                       <div className={isModifyAllowed?"dropdown":"hide"} id={'dropdown-'+item.id}>
                                          <React.Fragment>
                                          <button className="dropdown-toggle" type="button"
                                                id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)} >
                                                <input type="image" id={"img-action-"+item.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                          </button>
                                          <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(e,item.id)}>{LBL_EDIT}</Link>
                                                {/* (!item.primary_contact) && item.is_active && <Link className="dropdown-item delete" to="#" onMouseDown={(e)=>this.deleteBtnClick(item.user.id,fullName)}>{LBL_DELETE}</Link>*/}
                                          </div> 
                                          </React.Fragment>
                                       </div>
                                       </td>
                                    </tr>              
                                 )
                              }) }                       
                           </tbody>
                        </table>
                        <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                        <div className="clear-b-scroll-sector">&nbsp;</div>   
                     </div>
                  </div>                    
               </div>
               
               <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
               {LBL_CONFIRM_DELETE_ASSOC_USER+' '+this.state.activeUserName+"?"}
               </ModalWindow>
               <ModalWindow ref={this.modalUndoDelete} header={LBL_CONFIRM_UNDO_DELETE} type="confirm" deleteConfirmedItem={this.onActivateAction} resetModalForm={this.onModalFormReset}>
               {LBL_CONFIRM_UNDO_DELETE_ASSOC_USER+' '+this.state.activeUserName+"?"}
               </ModalWindow>
               
               <ModalWindow ref={this.modal} sameUser={Number(activeUserProfileId) > 0 && Number(activeUserProfileId)===Number(myProfileId)} header={Number(activeUserProfileId) > 0 && Number(activeUserProfileId)===Number(myProfileId) ? LBL_MY_PROFILE : (this.state.activeUserId ? LBL_EDIT : LBL_ADD )+' '+LBL_ASSOCIATE_USER} type="formSubmit" resetModalForm={this.onModalFormReset} showDeleteLinkLeft={showDeleteLinkLeft} showUndoDeleteLinkLeft={showUndoDeleteLinkLeft} deletePopup={this.deletePopup} deleteUndoPopup={this.deleteUndoPopup} > 
                  <AssociateAddEditComponent location={this.state.location} onAssocUserAddSuccess={this.onAssocUserAddSuccess} onAssocUserUpdateSuccess={this.onAssocUserUpdateSuccess} activeUserId={this.state.activeUserId} activeUserProfileId={this.state.activeUserProfileId} calledFrom='associates' fromEdit={true} />
               </ModalWindow>  
               


               {/* saveFormData={ (e)=>this.onSaveFormData()}  */}
               <ModalWindow ref="modal222" header={Number(activeUserProfileId) > 0 && Number(activeUserProfileId)===Number(myProfileId) ? LBL_MY_PROFILE : (this.state.activeUserId ? LBL_EDIT : LBL_ADD )+' '+LBL_ASSOCIATE_USER} type="formSubmit" resetModalForm={this.onModalFormReset} showDeleteLinkLeft={showDeleteLinkLeft} deletePopup={this.deletePopup} > 
                  <Form id="form_dataEntry" onSubmit={(e) => this.onSaveFormData(e)} encType="multipart/form-data">
                     <Form.Group>
                     <Toast toastDescription={toastMessagePop} toastFlag={toastFlagPop} toastSuccess={toastSuccessPop} closeToast={this.onCloseToast} />
                        <Row>
                           <div className="col-md-12 text-center">
                              <div className="company-logo">
                                 <img src={logoUrl} alt="Profile Name" />  
                                 <p className={isLogoValid?'logo-txt':'text-red logo-txt'}>
                                    <small>{logoLabel}</small>
                                    { (formErrors.profile_picture.length > 0) && 
                                       <div><small>{formErrors.profile_picture}</small></div>
                                    }
                                 </p>                                          
                                 <label htmlFor="file_userProfile"><i className="las la-pen"></i></label> 
                                 <input type="file" id="file_userProfile" name="file_userProfile" onChange={this.onHandleChange} accept=".png, .jpg, .jpeg"/>                                          
                              </div>
                           </div>
                        </Row>
                        
                        <Row>
                           <Col md={6}>
                              <div className="form-group">
                                 <label>{LBL_FIRST_NAME} </label>
                                    <div className="text-input"><input type="text" name="txt_first_name" onChange={this.onHandleChange} className={formErrors.first_name.length >0 ? "input-error" : ''} value={activeUserData.first_name || ''} /></div>
                              </div>
                           </Col>   
                           <Col md={6}>
                              <div className="form-group">
                                    <label>{LBL_LAST_NAME}</label>
                                    <div className="text-input"><input type="text" className={formErrors.last_name.length >0 ? "input-error" : ''} onChange={this.onHandleChange} name="txt_last_name" value={activeUserData.last_name || ''} /></div>
                              </div>
                           </Col>
                        </Row>
                        
                        <Row>
                           <Col md={6}>
                              <div className="form-group">
                                    <label>{LBL_MOBILE_NUMBER}</label>
                                    <div className={formErrors.mobile.length>0?'input-error':''}>
                                      <PhoneInput 
                                        country={PHONE_ISD_CODE}
                                        inputProps={{
                                          name: 'txt_mobile',
                                        }}
                                        value={activeUserData.mobile || PHONE_ISD_NUM}
                                        onChange={this.onPhoneInputChange} 
                                      />
                                   </div>
                              </div>
                           </Col>     
                           <Col md={6}>
                              <div className="form-group"> 
                                    <label>{LBL_EMAIL_ADDRESS}</label>
                                    <div className="input email-input"><input type="email" className={formErrors.email.length >0 ? "input-error" : ''} onChange={this.onHandleChange} name="txt_email" value={activeUserData.email || ''} />
                                    {formErrors.email.length >0 && formErrors.email!==MSG_REQUIRED && (
                                       <div className="text-red left-align text-12">{formErrors.email}</div>
                                    )} 
                                    <small className="text-red">{activeUserData.email_verified===false && activeUserData.email?'Not Verified':''}</small><Link className={activeUserData.email_verified===false&&activeUserData.email?'resend-btn float-right':'hide'} to="#" onClick={e => this.resendEmail(this.state.activeUserId)}>{LBL_RESEND_VERIFI_EMAIL+this.state.activeUserId}</Link>
                                    </div>
                              </div>
                           </Col>
                        </Row> 
                        
                        <Row>
                           <Col md={6}>
                              <div className="form-group">
                                    <label>{LBL_ROLE}</label>
                                    <div className="form-group select-input">
                                    <select name="sel_role" value={activeUserData.role} className={formErrors.role.length ? "input-error" : ''} onChange={this.onHandleChange} >
                                       <option value='0'>{LBL_SELECT_ROLE}</option>
                                       {rolesList.map((item,index) => { return (
                                       <option key={item.id} value={item.id} >{titleCase(item.name)}</option> )
                                       } ) } 
                                       {/* if(item.name.trim().toLowerCase()!=='admin') */}
                                    </select>
                                 </div>
                              </div>
                           </Col> 
                           <Col md={6}>
                              <div className="form-group"> 
                                    <label>{LBL_POSITION}</label>
                                    <div className="input-input"><input type="text" onChange={this.onHandleChange} name="txt_position" value={activeUserData.position || ''} /></div>
                              </div>
                           </Col>
                        </Row>
                        
                        <Row>
                           { (this.state.userGroup===LOGIN_AFFILIATE_GROUP) && <Col md={6}>
                              <div className="form-group">
                                 <label>{LBL_DEPARTMENT}</label>
                                 <div className="form-group multisel_textbox">
                                    {/* <div className="form-group select-input skills">
                                       <Multiselect  ref="multiSel" data={this.state.deptMultiSelList}
                                          onChange={selected =>this.handleChangeMultiSel(selected)}
                                    multiple />
                                    </div> */}
                                    <div className="form-group select-input skills" >
                                       <CustomMultiSelect data={this.state.deptMultiSelList}  onChange={selected =>this.handleChangeMultiSel(selected)} isTextBox={false} />
                                    </div>
                                 </div>                                 
                              </div>
                              
                              
                           </Col>
                           }

                           <Col md={6}>
                              <div className="form-group">
                                    <label>{LBL_STATUS}</label>
                                    <div className="form-group select-input">
                                    <select name="sel_status" value={activeUserData.status} onChange={this.onHandleChange} className={formErrors.status.length ? "input-error" : ''} disabled={Number(activeUserProfileId) > 0 && Number(activeUserProfileId)===Number(myProfileId)}>
                                       { (this.state.activeUserId===0) && 
                                          <option value='1'>{LBL_ACTIVE}</option>
                                       }
                                       { (this.state.activeUserId > 0) && 
                                          <option value='0'>{LBL_SELECT_STATUS}</option>
                                       }
                                       {(this.state.activeUserId > 0) && USER_STATUS.map((item,index) => { return (
                                       <option key={item.statusCode} value={item.statusCode} >{titleCase(item.statusString)}</option> )
                                       } ) }  
                                    </select>
                                    
                                 </div>
                              </div>
                           </Col>
                        </Row>

                        { (this.state.activeUserId > 0) && 
                        <Row>  
                           <Col md={6}>
                              <div className="form-group">
                                 <label><span>{LBL_USER_CREATED_ON} :<strong> { (activeUserData.created_on!=='') && (activeUserData.created_on!==null) && <Moment format="DD/MM/YYYY HH:mm">{activeUserData.created_on}</Moment>} {/*Jan 1, 2020 9:10 AM */} </strong></span></label> 
                              </div>
                           </Col>
                           <Col md={6}>
                              <div className="form-group">
                                 <label><span>{LBL_LAST_LOGGED_IN} :<strong> { (activeUserData.last_login!=='') && (activeUserData.last_login!==null) && <Moment format="DD/MM/YYYY HH:mm">{activeUserData.last_login}</Moment>} {/*Mar 1, 2020 11:10 PM */} </strong></span></label>
                              </div>
                           </Col>
                        </Row> }  
                        {/* <div><Multiselect data={this.state.deptMultiSelList} multiple /></div> */}
                         
                     </Form.Group>
                    
                  </Form>
                  
               </ModalWindow>
                             
            </div>
            
            <Filter>
               {/* <FilterClient /> */}
            </Filter>
         </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => { 
   return {
      status:state.assocUsers.status,
      statusText:state.assocUsers.statusText,
      activity:state.assocUsers.activity,
      subactivity:state.assocUsers.subactivity,  
      assocUsersAllData: state.assocUsers.assocUsersAllData,
      departmentsList : state.assocUsers.departmentsList,
      rolesList : state.assocUsers.rolesList,
      totalPage:state.assocUsers.totalPage,
      numRows:state.assocUsers.numRows,
      count:state.assocUsers.count,
      errorData:state.assocUsers.errorData,
      isFilterOn: state.commons.isFilterOn,   
      assocUserActive: state.commons.assocUserActive
   }
};


const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
         assUserListAction:assUserListAction,
         assUserDeptListAction:assUserDeptListAction, 
         assUserRolesListAction:assUserRolesListAction, 
         assUserAddAction:assUserAddAction,
         assUserUpdateAction:assUserUpdateAction, 
         associateUserDeleteAction:associateUserDeleteAction, 
         resendEmailAction:resendEmailAction,
         assocUserDeactiveAction:assocUserDeactiveAction,
         clearAction:clearAction,
         associateUserActivateAction:associateUserActivateAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(AssociatesListComponent);